module.exports = __webpack_public_path__ + "img/player.44bf6a90.png";